
import { createApiClient } from 'Network/ApiClient';

export const ActivityToActivityRelationAxiosInstance = createApiClient('user/');


